import React, { lazy } from "react"
import { Router, Switch, Route, Redirect } from "react-router-dom"

import DefaultTemplate from "templates/DefaultTemplate"
import history from "govHistory"

// MainのJSファイルに含めるファイル
import Callback from "pages/Callback"
import Error from "pages/Error"
import Thanks from "pages/Thanks"

const AgreementSelection = lazy(() => import("pages/AgreementSelection"))
const GovRouter = () => {
  return (
    <Router history={history}>
      <DefaultTemplate>
        <Switch>
          <Route path="/" exact={true} component={AgreementSelection} />
          <Route path="/error" exact={true} component={Error} />
          <Route path="/thanks" exact={true} component={Thanks} />
          <Route path="/callback" exact={true} component={Callback} />
          <Route
            render={() => {
              return <Redirect to={"/"} />
            }}
          />
        </Switch>
      </DefaultTemplate>
    </Router>
  )
}

export default GovRouter
